//import MetisMenu from "metismenujs/dist/metismenujs";
import { iconService } from "@/api/icon.service";
import { ability } from '@/store/ability';

export const state = {
  menu: [],
}

export const actions = {
  loadMenu({ commit, rootState }, callback) {
    const properties = rootState.property.properties;
    const menuItems = {
      properties: {
        id: 1,
        label: "Properties",
        icon: "fa fa-home",
        namespace: '/properties',
        subItems: [],
      },
    }

    properties.forEach((property, propIndex) => {
      property.areas.sort((a, b) => a.name.localeCompare(b.name));

      let propMenuItem = {
        id: propIndex + 1,
        parentId: 1,
        label: property.name,
        propertyId: property.id,
        link: `/properties/${property.id}`,
        thumbnail: (property.photos.length ? property.photos[0].image_url : ''),
        icon: "fa-home",
        subItems: [],
        virtualTourLink: property.activation_info.virtual_tour_link,
        roofReport: property.documents.find(doc => doc.name == 'Roof Report'),
        itemCategories: {}
      };
       if (ability.can('read', 'Area')) {
        property.areas.forEach((area, areaIndex) => {
          area.items.sort((a, b) => {
            if (!a.category) return 1; // Items without category go to the end
            if (!b.category) return -1;
            return a.category.localeCompare(b.category);
          });

          let areaMenuItem = {
            id: areaIndex + 1,
            parentId: propIndex + 1,
            label: `${area.name}(${area.nickname || ''})`,
            areaId: area.id,
            link: `/properties/${property.id}/areas/${area.id}`,
            icon: "fa-home",
            itemCategories: {}
          };

          // Check if the user can read Item
          if (ability.can('read', 'Item')) {
            area.items.forEach(item => {
              if (!item.category) return;
              const topcat_slug = iconService.getCategorySlug(item.category),
                    topCategory = iconService.getIconByCategory(topcat_slug); // Null if not found

              if (topCategory) {
                if (!areaMenuItem.itemCategories[topcat_slug]) {
                  areaMenuItem.itemCategories[topcat_slug] = {
                    label: item.category,
                    category: topCategory,
                    link: `/properties/${property.id}/areas/${area.id}/category/${topcat_slug}`,
                  };
                }

                if (!propMenuItem.itemCategories[topcat_slug]) {
                  propMenuItem.itemCategories[topcat_slug] = {
                    label: item.category,
                    category: topCategory,
                    link: `/properties/${property.id}/category/${topcat_slug}`,
                  };
                }
              }
            });
          }

          propMenuItem.subItems.push(areaMenuItem); // Add area menu item if user can read Area
        });
      }

      menuItems.properties.subItems.push(propMenuItem);
    });

    commit('menuItems', menuItems);
    if (callback) callback(Object.values(menuItems));
  },
}

export const mutations = {
  menuItems(state, menuItems) {
    state.menu = menuItems;
  },
  updateMenuItemLabel(state, { label, propertyId, areaId }) {
    let menuItem = state.menu.properties.subItems.find(p => p.propertyId == propertyId);
    if (areaId) menuItem = menuItem.subItems.find(a => a.areaId == areaId);

    menuItem.label = label;
  },
  // Add area to existing menu state
  addMenuItem(state, { property, area }) {
    let menuItem = state.menu.properties.subItems.find(p => p.propertyId == property.id);

    menuItem.subItems.push({
      id: menuItem.subItems.length,
      parentId: menuItem.id,
      label: `${area.name}(${area.nickname || ''})`,
      areaId: area.id,
      link: "/properties/" + property.id + "/areas/" + area.id,
      icon: "bx-home-circle"
    });
  },
}
